import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseGoodCategoryService } from 'src/app/_services/dispo/base-good-category.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal,NgbModalConfig, NgbModalModule} from '@ng-bootstrap/ng-bootstrap';

import { FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';



@Component({
  selector: 'app-team-dayview',
  templateUrl: './team-dayview.component.html',
  styleUrls: ['./team-dayview.component.css']
})
export class TeamDayViewComponent implements OnInit {
  analyseId='';
  aCatObject: any;
  content?: string;
  isNew? : Boolean;
  customerData: any;
  customerForm: any;
  submitted = false;
  boolList: any = [{id: 0, name: 'nein'},{id: 1,name: 'ja'}];


  constructor(
    private route: ActivatedRoute, 
    private router: Router,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private modalConfig: NgbModalConfig,
    private baseGoodCategoryService: BaseGoodCategoryService
    
    ) {
      modalConfig.backdrop = 'static';
     }
    

  ngOnInit(): void {
    this.analyseId = this.route.snapshot.params.id;
    this.baseGoodCategoryService.show(this.analyseId).subscribe(
      data => {
        this.aCatObject = data; 
        //this.isNew = this.analyseService.getIsNew();
        if(!this.aCatObject.id) {this.isNew = true};
        this.setForm(data);     //fill form
        this.showModal = true;
      },
      err => {
        this.content = JSON.parse(err.error).message;
      }
    );
  }

  showModal = false;

  ngAfterContentInit() {
    this.showModal = true;
  }

  setForm(data) {
    this.customerForm = this.fb.group({
      id:                         [data.id,Validators.required],
      name:                       [data.name,Validators.required],
      is_panel:                   [data.is_panel,Validators.required],
    });
  }

  submit() {
    this.submitted = true;
    if(this.isNew) {
      alert('store');
      //store
      this.baseGoodCategoryService.store(this.customerForm.value).subscribe(
        data => {
          this.customerData = data;
          this.toastr.success('Analysekategorie wurde erfolgreich angelegt', 'Analysekategorie erfasst');
        },
        err => {
          this.toastr.warning(err.error.message, 'Ein Fehler ist aufgetreten');
  
        }
      );
    } else {

      //update
      this.baseGoodCategoryService.update(this.customerForm.value).subscribe(
        data => {
          this.customerData = data;
          this.toastr.success('Analysekategorie wurde erfolgreich geändert', 'Analysekategorie gepeichert!');
        },
        err => {
          this.toastr.warning(err.error.message, 'Ein Fehler ist aufgetreten');

        }
      );
    };
  }

  delete() {
    this.baseGoodCategoryService.delete(this.aCatObject).subscribe(
      data => {
        this.toastr.success('Analyse wurde unwiderruflich gelöscht', 'Daten gelöscht!');
      },
      err => {
        this.content = JSON.parse(err.error).message;
      }
    );
  }

  goBack() {
    this.router.navigate(['../../'],{ relativeTo: this.route }).then(() => {
      //window.location.reload();    
  });
    
    //this.router.navigateByUrl("/immo-details/' + id + '/immo-base");
  }

  onDialogClick(event: UIEvent) {
    // Capture click on dialog and prevent it from bubbling to the modal background.
    event.stopPropagation();
    event.cancelBubble = true;
  }

}
